import { render, staticRenderFns } from "./serverType.vue?vue&type=template&id=eb35d6cc&scoped=true"
import script from "./serverType.vue?vue&type=script&lang=js"
export * from "./serverType.vue?vue&type=script&lang=js"
import style0 from "./serverType.vue?vue&type=style&index=0&id=eb35d6cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb35d6cc",
  null
  
)

export default component.exports